import React from 'react'

function About() {
  return (
    <>
            <section class="about-section text-center" id="viewna">
                <div class="container px-4 px-lg-5">
                    <div class="row gx-4 gx-lg-5 justify-content-center">
                        <div class="col-lg-8">
                            <h2 class="text-white mb-4">For more informations</h2>
                            <p class="text-white-50">
                                สามารถอ่าน ข้อมูล ข่าวสาร และ รีวิว เพิ่มเติมได้ที่ 
                                <a href="https://www.facebook.com/viewnaTH">    Viewna Cafe Fanpage</a>
                                
                            </p>
                        </div>
                    </div>
                    <img class="img-fluid" src="" alt="" />
                </div>
            </section>
    </>
  )
}

export default About